export default __webpack_public_path__ + "static/media/Logo.fe932e59.png";